import { useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import { Backdrop, Container, Grow, Modal, Stack, styled, Typography } from "@mui/material";
import AutoStrategyClose from "./AutoStrategyClose";
import CustomPaper from "../../../_components/CustomPaper";
import Text from "../../../_components/Text";

interface Props {
  open: boolean;
  onClose: (value: boolean) => void;
  id: string;
  displayedId: string;
}

const CustomBackdrop = styled(Backdrop)(() => ({
  backdropFilter: "blur(6px)",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
}));

const closeModalContainerStyles = {
  position: "fixed",
  top: "25%",
  left: 0,
  zIndex: 100,
  width: "100%",
  paddingLeft: "20px !important",
  paddingRight: "20px !important",
};

const AutoStrategyConfirmPopup = (props: Props) => {
  const theme = useTheme();

  useEffect(() => {
    const muiContainers = document.querySelectorAll(".MuiContainer-root");
    if (props.open) {
      muiContainers.forEach((container) => {
        (container as HTMLElement).classList.add("ui-disabled");
      });
    } else {
      muiContainers.forEach((container) => {
        (container as HTMLElement).classList.remove("ui-disabled");
      });
    }

    return () => {
      muiContainers.forEach((container) => {
        (container as HTMLElement).style.opacity = "1";
      });
    };
  }, [props.open]);

  const handleClose = () => props.onClose(false);

  return (
    <Modal
      open={props.open}
      onClose={handleClose}
      slots={{ backdrop: CustomBackdrop }}
      slotProps={{}}
    >
      <Grow in={props.open}>
        <Container className={"NoOpacity"} maxWidth={"xl"} sx={closeModalContainerStyles}>
          <CustomPaper sx={{ borderRadius: 2, paddingTop: 2 }} color={theme.myTheme.colors.gray300}>
            <Stack direction={"column"} spacing={1}>
              <Stack direction={"column"} spacing={2}>
                <Text variant="h3">Are You Sure You Want to Close Bot?</Text>
                <Text variant="regular">
                  Closing this bot will immediately stop its trading activities, and any ongoing
                  orders will be canceled. You can restart it later, but the current session’s data
                  will be lost.
                </Text>
              </Stack>

              <AutoStrategyClose
                onChange={props.onClose}
                displayedId={props.displayedId}
                id={props.id}
              />
            </Stack>
          </CustomPaper>
        </Container>
      </Grow>
    </Modal>
  );
};

export default AutoStrategyConfirmPopup;
